/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SideInputs */

const en_us2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominant side`)
};

const pt_br2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const es_419_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const pt_pt2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const fr_fr2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Côté dominant`)
};

const de_de2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominante Seite`)
};

const it_it2_profile_row_side = /** @type {(inputs: Profile_Row_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lato dominante`)
};

/**
* | output |
* | --- |
* | "Dominant side" |
*
* @param {Profile_Row_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_side = /** @type {((inputs?: Profile_Row_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_side(inputs)
	if (locale === "es-419") return es_419_profile_row_side(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_side(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_side(inputs)
	if (locale === "de-DE") return de_de2_profile_row_side(inputs)
	if (locale === "it-IT") return it_it2_profile_row_side(inputs)
	return en_us2_profile_row_side(inputs)
});
export { profile_row_side as "profile.row_side" }